export default __webpack_public_path__ + "static/media/regulamento-rh-mario-ito.a465a7fb.pdf";